var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame",style:({height:_vm.frameHeight+'px', width: _vm.frameWidth+'px', zoom: _vm.zoom, background: _vm.bgColor})},[_c('div',{style:(_vm.divStyle)},[_c('img',{staticClass:"image",style:(_vm.imgStyle),attrs:{"src":_vm.img}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65b6dd08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/design/Preview.vue
// module id = null
// module chunks = 